module.exports = __webpack_public_path__ + "static/media/seed.9be979cd.svg";